export default __webpack_public_path__ + "static/tylersmith-5d67a14079279a465e309f2c6a8a6c78.png";